// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs';

import { of } from 'rxjs';

// Ngrx
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

// Actions
import * as cartActions from '../cart/cart.actions';

// Services
import { SoledadCartService } from '../../shared/services/b2b/cart.service';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class CartEffects {
    constructor(private actions$: Actions, private cartService: SoledadCartService) {}

    validateCart$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(cartActions.CartActionTypes.DO_VALIDATE_CART),
            switchMap((action: cartActions.DoValidateCart) =>
                this.cartService
                    .validateItems(
                        action.payload.user,
                        action.payload.cart,
                        action.payload.recalculate,
                        action.payload.parts,
                        action.payload.modParts,
                        action.payload.checkout
                    )
                    .pipe(
                        map((data) => new cartActions.DoValidateCartOK(data)),
                        catchError((error) => {
                            return of(new cartActions.DoValidateCartKO({ error }));
                        })
                    )
            )
        )
    );

    clearCart$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(cartActions.CartActionTypes.DO_CLEAR),
            switchMap((action: cartActions.DoClear) =>
                of(this.cartService.clear()).pipe(
                    map((data) => new cartActions.DoClearOK()),
                    catchError((error) => {
                        return of(new cartActions.DoClearKO());
                    })
                )
            )
        )
    );
}
